import FormLogin from '@/components/FormLogin'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: FormLogin,
		vueInit: null,
	}

	let page = vuewidget(dom, options)
	return page
}